import React, { useContext, useEffect, useState } from 'react'
import { 
    Container,
    ButtonImg,
    ButtonText
 } from './style'
import arrow from '../../../assets/stock/LoadMoreButton/arrow-down.svg'
import OrdersContext from '../../../contexts/OrdersContext'

const LoadMoreButton: React.FC = () => {
    const { quantity, setQuantity } = useContext(OrdersContext)

    const raiseQuantity = () => {
        const newQuantity = quantity + 9
        setQuantity(newQuantity)
    }

    return (
        <Container onClick={raiseQuantity}>
            <ButtonImg src={arrow} alt='Arrow pointing down' />
            <ButtonText>Carregar mais</ButtonText>
        </Container>
    )
}

export default LoadMoreButton